import axios from 'axios'

axios.defaults.baseURL = process.env.API_ROOT
axios.defaults.withCredentials = true

/**
 * 检查响应结果状态
 * @param response
 * @returns {*}
 */
function checkStatus(response) {
  if (response.status === 200 || response.status === 304) {
    return response;
  }
  return {
    data: {
      code: response.status,
      message: response.statusText,
      data: response.statusText
    }
  };
}

/**
 * 检查结果状态
 * @param res
 * @returns {*}
 */
function checkCode(res) {
  if (res.data.status != undefined && res.data.status != null) {
    //返回状态码不为0
    if (res.data.status == 'success') {
      console.info('success')
    }else if(res.data.status == 'fail'){
      console.info('失败')
    }else{
      console.info('异常')
    }
  }
  return res;
}

/**
 * 提交新增数据
 * @param url
 * @param data
 * @returns {Promise.<TResult>|*}
 */
function post(url, data) {
  return axios({
    method: "post",
    url: url,
    data: JSON.stringify(data),
    params: [],
    timeout: 30000,
    headers: {
      'sessionId' : JSON.parse(sessionStorage.getItem('session')),
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/Json; charset=UTF-8"
    }
  }).then(checkStatus).then(checkCode)
}

function post1(url, data) {
  return axios({
    method: "post",
    url: url,
    data: JSON.stringify(data),
    params: [],
    timeout: 30000,
    headers: {
      // 'sessionId' : JSON.parse(sessionStorage.getItem('session')),
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/Json; charset=UTF-8"
      // "Access-Control-Allow-Origin":'*'
    }
  }).then(checkStatus).then(checkCode)
}
/**
 * 提交新增数据
 * @param url
 * @param data
 * @returns {Promise.<TResult>|*}
 */
function postObject(url, data) {
  return axios({
    method: "post",
    url: url,
    data: data,
    params: [],
    timeout: 30000,
    headers: {
      'sessionId' : JSON.parse(sessionStorage.getItem('session')),
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    }
  }).then(checkStatus).then(checkCode)
}

/**
 * 同步
 * @param {*} url
 * @param {*} data
 */
async function postAsync(url, data) {
  try {
    let res = await axios({
      method: "post",
      url: url,
      data: JSON.stringify(data),
      params: [],
      timeout: 30000,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/Json; charset=UTF-8"
      }
    });
    res = res.data;
    return new Promise((resolve, reject) => {
      if (Number(res.statusCode) === 1) {
        resolve(res);
      } else {
        reject(res);
      }
    })
  } catch (err) {
    // return (e.message)
    alert('服务器出错')
    console.log(err)
  }
}

/**
 * 获取数据
 * @param url
 * @param params
 * @returns {Promise.<TResult>|*}
 */
function get(url, data) {
  return axios({
    method: "get",
    url: url,
    params: data,
    timeout: 30000,
    dataType: "json",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "X-Requested-With": "XMLHttpRequest",
      'sessionId' : JSON.parse(sessionStorage.getItem('session'))
    }
  }).then(checkStatus).then(checkCode)
}

export default {
  axios,
  post,
  postObject,
  get,
  post1,
}



// WEBPACK FOOTER //
// ./src/utils/axios.js